import { ImageIcon, ImageIconV2 } from '@mybridge/icons';
import { IconButton } from '@mybridge/ui/icon-button';
import { Input } from '@mybridge/ui/input';
import { Box, HStack } from '@mybridge/ui/layout';
import { Text } from '@mybridge/ui/text';
import { Tooltip } from '@mybridge/ui/tooltip';
import { useContext, useRef, useState } from 'react';
import { PostFormContext } from '../context';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';

export const MediaPicker = ({ ...props }) => {
  const {
    gifs,
    images,
    videos,
    setVideos,
    setImages,
    newFileInputRef,
    handleMediaFilesChange,
    setMediaUpdated,
    isUploading,
    uploadsList,
  } = useContext(PostFormContext);
  const { t } = useTranslator();
  
  const [iconColor, setIconColor] = useState('');

  const activeUpload = uploadsList?.find((item) =>
    ['initiating', 'uploading', 'completing'].includes(item.status)
  );
  const activePercentage = activeUpload?.percentage ?? 0;

  const handleMouseEnter = () => {
      setIconColor('#ffffff');
  };

  const handleMouseLeave = () => {
    setIconColor('');
  };

  return (
    <HStack 
      spacing={0}>
      <Tooltip
        hasArrow
        placement="top"
        variant="round"
        label={t('createPost.addImagesVideo') ||  "Add Images/Video"}
      >
        <IconButton
          borderRadius="30px"
          padding="6px"
         _hover={{ background: '#3D5A80' }}
         onMouseEnter={handleMouseEnter}
         onMouseLeave={handleMouseLeave}
          /* isDisabled={
            gifs?.length > 0 || videos?.length > 0 || images?.length >= 5
          } */
          isDisabled={
            gifs?.length > 0 || videos?.length > 0 || images?.length >= 5 || isUploading
          }
          isLoading={isUploading}
          onClick={() => newFileInputRef?.current?.click?.()}
        >
          <ImageIconV2 color={iconColor} />
        </IconButton>
      </Tooltip>
      {isUploading && (
        <Text fontSize="xs" fontWeight="bold" color="brandPrimary.500" ml={2}>
          {activePercentage}%
        </Text>
      )}
      <Box w="0" h="0" overflow="hidden">
        <Input
          multiple
          onChange={handleMediaFilesChange}
          ref={newFileInputRef}
          w={0}
          h={0}
          visibility="hidden"
          type="file"
          accept=".jpg,.jpeg,.png,.mp4,.avi,.mov,.wmv"
        />
      </Box>
    </HStack>
  );
};
